import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { message, Tooltip } from "antd";
import styles from "../layoutWrapper.module.less";
import { useHistory, useLocation } from "react-router-dom";
import { getUserLogoutRequest } from "../requests";
import { fetchPortalConfig } from "../../../store/portal/actions";
import { PORTAL_URL } from "../../../constants/urls";

import { PendingDot } from '../../Status/Pending';
import { ReviewingDot } from '../../Status/Reviewing';
import { PlannedDot } from '../../Status/Planned';
import { InProgressDot } from '../../Status/InProgress';
import { CompletedDot } from '../../Status/Completed';
import { ClosedDot } from '../../Status/Closed';

const LeftSidebar = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  
  const stack = useMemo(() => location.pathname.split("/") || [], [location.pathname]);

  const portalConfig = useSelector((state) => state.portal);
  const subdomain = portalConfig?.config?.portal?.subdomain || "";

  useEffect(() => {
    dispatch(fetchPortalConfig(stack[1]));
  }, [dispatch, stack]);

  const queryString = location.search;
  const queryParams = new URLSearchParams(queryString);
  const status = queryParams.get('status');

  const handleNavigationClick = async (key) => {
    const totalBacks = stack.length - 3;
    let back = "../";
    let backString = "./";
    for (let i = 0; i < totalBacks; i++) {
      backString = backString + back;
    }
    if (key !== "logout") {
      history.push(`${backString}${key}`);
    } else {
      try {
        const res = await getUserLogoutRequest();
        if (res.data.success) history.push("/auth/login");
        else message.error("Some Error Occured");
      } catch (err) {
        message.error("Some Error Occured");
      }
    }
  };

  const openPortalBoard = () => {
    window.open(
      `${PORTAL_URL}/${subdomain}`,
      "_blank"
    )
  };

  return (
    <>
      <div className={styles.navSection}>
        <div className={styles.heading}>Requests</div>
        <div className={`${styles.statusItem} ${status === "pending" ? styles.active : ""}`} onClick={() => handleNavigationClick("requests?status=pending")}><PendingDot /> Pending</div>
        <div className={`${styles.statusItem} ${status === "reviewing" ? styles.active : ""}`} onClick={() => handleNavigationClick("requests?status=reviewing")}><ReviewingDot /> Reviewing</div>
        <div className={`${styles.statusItem} ${status === "planned" ? styles.active : ""}`} onClick={() => handleNavigationClick("requests?status=planned")}><PlannedDot /> Planned</div>
        <div className={`${styles.statusItem} ${status === "in-progress" ? styles.active : ""}`} onClick={() => handleNavigationClick("requests?status=in-progress")}><InProgressDot /> In Progress</div>
        <div className={`${styles.statusItem} ${status === "completed" ? styles.active : ""}`} onClick={() => handleNavigationClick("requests?status=completed")}><CompletedDot /> Completed</div>
        <div className={`${styles.statusItem} ${status === "closed" ? styles.active : ""}`} onClick={() => handleNavigationClick("requests?status=closed")}><ClosedDot /> Closed</div>
        <div className={styles.heading}>Workspace</div>
        <div className={styles.item} onClick={() => handleNavigationClick("releases")}><i className="ri-exchange-2-fill"></i> Changelog</div>
        <div className={styles.item} onClick={() => handleNavigationClick("integrations")}><i className="ri-apps-fill"></i> Integrations</div>
        <div className={styles.item} onClick={() => handleNavigationClick("community")}><i className="ri-group-fill"></i> Community</div>
        <div className={styles.item} onClick={() => handleNavigationClick("settings")}><i className="ri-settings-5-fill"></i> Settings</div>
        <div className={styles.item} onClick={openPortalBoard}><i className="ri-terminal-window-fill"></i>Public Board <Tooltip title="Open Public Board in new window"><span className={styles.externalLinkIcon}><i className="ri-external-link-line"></i></span></Tooltip></div>
      </div>
      <div className={styles.profileSection}>
        {
          // TODO: Add profile here
        }
      </div>
    </>
  );
};

export default LeftSidebar;
